<template>
  <div class="general-setting-component">
    <div class="setting-item">
      <span class="item-title">显示成员举手</span>
      <el-switch
        class="live-room-switch"
        v-model="showRaiseHandValue"
        :active-value="true"
        :inactive-value="false"
        active-color="#165DFF"
        inactive-color="#3F3F46"
      ></el-switch>
    </div>
    <!-- <div class="setting-item">
      <span class="item-title">进出教室通知</span>
      <el-switch
        class="live-room-switch"
        v-model="classEnterExitNotice"
        :active-value="true"
        :inactive-value="false"
        active-color="#165DFF"
        inactive-color="#3F3F46"
      ></el-switch>
    </div> -->
    <div class="sub-title">上台权限设置</div>

    <div class="setting-item" v-if="roomInfo.mode != 1">
      <span class="item-title">摄像头</span>
      <el-switch
        class="live-room-switch"
        v-model="cameraPermission"
        :active-value="1"
        :inactive-value="2"
        active-color="#165DFF"
        inactive-color="#3F3F46"
      ></el-switch>
    </div>
    <div class="setting-item">
      <span class="item-title">麦克风</span>
      <el-switch
        class="live-room-switch"
        v-model="micPermission"
        :active-value="1"
        :inactive-value="2"
        active-color="#165DFF"
        inactive-color="#3F3F46"
      ></el-switch>
    </div>
    <div class="setting-item">
      <span class="item-title">白板</span>
      <el-switch
        class="live-room-switch"
        v-model="whiteboardPermssion"
        :active-value="1"
        :inactive-value="2"
        active-color="#165DFF"
        inactive-color="#3F3F46"
      ></el-switch>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { updateRoomStatus, getRoomInfo } from "@saas/server-api/src/live-sdk";
export default {
  data() {
    return {
      classEnterExitNotice: false,
    };
  },
  mounted() {
    this.getRoomInfo();
  },
  computed: {
    ...mapState("live", ["showRaiseHand", "roomInfo"]),
    showRaiseHandValue: {
      get() {
        return this.showRaiseHand;
      },
      set(value) {
        this.setShowRaiseHand(value);
      },
    },
    // 上台摄像头权限
    cameraPermission: {
      get() {
        return this.roomInfo.up_stage_video;
      },
      set(value) {
        this.updateRoomStatus({ up_stage_video: value });
      },
    },
    // 上台麦克风权限
    micPermission: {
      get() {
        return this.roomInfo.up_stage_audio;
      },
      set(value) {
        this.updateRoomStatus({ up_stage_audio: value });
      },
    },
    // 上台白板权限
    whiteboardPermssion: {
      get() {
        return this.roomInfo.up_stage_whiteboard;
      },
      set(value) {
        this.updateRoomStatus({ up_stage_whiteboard: value });
      },
    },
  },
  methods: {
    ...mapMutations("live", ["setShowRaiseHand", "setRoomInfo"]),
    // 更改房间状态
    updateRoomStatus(params) {
      updateRoomStatus({
        id: this.roomInfo.id,
        ...params,
      }).then((res) => {
        if (res.code === 1) {
          this.setRoomInfo(params);
        } else {
          this.$darkMessage.error(res.message);
        }
      });
    },
    async getRoomInfo() {
      let { code, data, message } = await getRoomInfo({
        room_id: this.roomInfo.id,
      });
      if (code === 1) {
        this.setRoomInfo(data || {});
      } else {
        this.$darkMessage.error(message);
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
$border-color: #27272a;
.general-setting-component {
  .sub-title {
    font-weight: 400;
    font-size: 14px;
    color: #c9cdd4;
    margin-bottom: 8px;
  }
  .setting-item {
    background: #27272a;
    border-radius: 12px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    margin-bottom: 12px;
    .item-title {
      font-weight: 400;
      font-size: 16px;
      color: #ecedee;
      line-height: 1;
    }
  }
}
::v-deep .el-switch__core {
  width: 54px !important;
  height: 30px;
  border: none;
  border-radius: 15px;
  &::after {
    width: 24px;
    height: 24px;
    top: 3px;
    left: 2px;
  }
}
::v-deep .el-switch.is-checked .el-switch__core::after {
  margin-left: -26px !important;
}
</style>
